import { render, staticRenderFns } from "./ServiceRequirementSyncRadio.vue?vue&type=template&id=bb9c5024&"
import script from "./ServiceRequirementSyncRadio.vue?vue&type=script&lang=js&"
export * from "./ServiceRequirementSyncRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports